import React, { Component } from "react"
import { Seo } from "../components/Seo"
import Styles from "./TextContent.module.css"

class ServiceInfo extends Component {
  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <section className={[Styles.pageContent, Styles.container].join(" ")}>
        <h2 className={Styles.heading}>Tietoa Palvelusta</h2>
        <p>
          Business Tampereen yritystietopalvelu kerää yhteen ajantasaiset tiedot Tampereen kaupunkiseudun 
          yrityksistä perustuen eri rekistereihin ja yritysten niihin ilmoittamiin tietoihin.
        </p>
        <p>
          Palvelun tiedot kaupunkiseudun yrityskannasta, aktiivisista yrityksistä sekä rekisteröidyistä 
          ja lopetetuista yrityksistä Profinder-dataan ja Profinderin yhdistämiin muihin yritystiedon 
          lähteisiin. Lisäksi palvelussa käytetään Tilastokeskuksen yritysrekisteritietoja, 
          Verohallinnon (yritysten maksamat verot kotikunnan mukaan) ja 
          Business Finlandin (myönnetty TKI-rahoitus) tuottamia tietoja.
        </p>
        <p>
          Palvelusta on mahdollista hakea tietoa yksittäisistä yrityksistä, eri hakukriteerien avulla 
          muodostettuja yrityslistauksia.
        </p>
        <h3 className={Styles.heading}>Aktiiviset yritykset</h3>
        <p>
          Yritys on aktiivinen, kun se on rekisteröity kaupparekisteriin sekä vähintään yhteen toiseen 
          rekisteriin (ALV-rekisteriin, ennakkoperintärekisteriin, tai työnantajarekisteriin) tai 
          yrityksellä on vähintään yksi tilinpäätös viimeiseltä kolmelta tilikaudelta, eikä sillä ole 
          mitään erityistilannetta (konkurssi, saneeraus, selvitystila, toiminta keskeytynyt tai 
          toiminta lakannut). Viimeisen kuuden kuukauden sisään perustetut yritykset ovat 
          automaattisesti aktiivisia.
        </p>
        <h3 className={Styles.heading}>Rekisteröidyt yritykset</h3>
        <p>
          Rekisteröidyt yritykset näyttää Kaupparekisteriin rekisteröityjen yritysten lukumäärän. 
          Oletuksena etusivulla näkyy tieto kaikista kuluvan vuoden aikana rekisteröidyistä yrityksistä 
          kaupunkiseudulla.
        </p>
        <h3 className={Styles.heading}>Rekisteristä poistetut</h3>
        <p>
          Rekisteristä poistetut ovat yrityksiä, jotka eivät täytä palvelun aktiivisen yrityksen määritelmää.
        </p>
        <p>
          Yrityskannan tiedot päivittyvät kerran viikossa Profinder yritystietopalvelun datalla.
        </p>
        <h3 className={Styles.heading}>Vastuuvapauslauseke</h3>
        <p>
          Palvelussa esitetyt tiedot voivat muuttua ilman erillistä ilmoitusta, ja kolmannen osapuolen lähteiden mahdolliset virheet tai puutteet voivat vaikuttaa palvelun sisältöön. Suosittelemme tarkistamaan kriittiset tiedot alkuperäisistä lähteistä ennen päätöksentekoa. Palvelun käyttö tapahtuu omalla vastuulla eikä Business Tampere Oy vastaa mahdollisista virheistä tai niiden seurauksista.
        </p>
        <Seo title="Tietoa palvelusta" />
      </section>
    )
  }
}

export default ServiceInfo
